// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.header-action.base-button{--button-position:relative}.header-action__badge{background:var(--c-black);border-radius:50%;color:var(--c-white);font-size:10px;font-weight:var(--font-weight--bold);height:20px;line-height:20px;position:absolute;right:0;top:0;width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
